import { render, staticRenderFns } from "./MaterialMapCard.vue?vue&type=template&id=2ef4a363&"
import script from "./MaterialMapCard.vue?vue&type=script&lang=js&"
export * from "./MaterialMapCard.vue?vue&type=script&lang=js&"
import style0 from "./MaterialMapCard.vue?vue&type=style&index=0&id=2ef4a363&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports